import logo from '../assets/logocedric.png';

function PreHeader() {

	return (
        <div class="backNavBar">
            <a href="https://cedric-guette.com/portfolio">
                <div class="backButton">
                </div>
            </a>
            <img src={ logo } alt="Cédric Guetté Développeur Fullstack" />
        </div>
    )
}

export default PreHeader
